function TodoItemAutoComplete () {
    var self = this
    this.notifyActionDetected = function (vm, ItemType, ItemID, actionType) {
        // window.console.log(`notifyActionDetected`, ItemType, ItemID)
        let todoItem = self.isTodoItemCompletable(vm, ItemType, ItemID)
        // window.console.log(`isTodoItemCompletable`,todoItem)
        if (todoItem) {
            // 如果是簽核日誌獎金，就自動完成
            if (ItemType == 'taskWorkingItem' && actionType == '簽核獎金') {
                self.complete(vm, todoItem.ID)
            } else {
                //跳出通知
                // window.console.log(`request alert confirm`)
                self.complete(vm, todoItem.ID)
                // vm.$alertConfirm(`偵測到以下待辦事項已經完成，是否劃掉?<br><i>${todoItem.Event.Content}，${todoItem.Content}</i><br>`, function () {
                //     self.complete(vm, todoItem.ID)
                // });
            }
        }
    }

    // project -> 請分配部門預算
        // 建立部門預算時，參數傳遞 Project & ProjectID
    // taskWorkingItem -> 請審核 (level > 10)
        // 審核後，參數傳遞 taskWorkingItem & taskWorkingItemID
    // taskWorkingItem -> 請審核 (level = 10)
        // 審核後
    // projectDepartmentBudget -> 請分配任務
        // 分配任務時
    // workOrder -> 請派工
        // 派工時
    // workOrder -> 請協助協調
        // 協調時
    // leaveForm -> 請審核
        // 審核後
    this.isTodoItemCompletable = function (vm, ItemType, ItemID) {
        var completableTodoItem = null
        var todoItems = vm.$store.getters.todoItems

        for(var i = 0; i < todoItems.length; ++i) {
            var todoItem = todoItems[i]
            if (todoItem.Event.ItemType == ItemType && todoItem.Event.ItemID == ItemID) {
                if (!todoItem.DoneAt) completableTodoItem = todoItem
                break
            }
        }

        return completableTodoItem
    }
    this.complete = function (vm, TodoItemID) {
      vm.isLoading = true;
      vm.$services.todoItem
        .done(vm, TodoItemID)
        .then(() => {
          let idx = vm.$store.getters.todoItems.findIndex(o => o.ID == TodoItemID);
          if (idx >= 0) {
            vm.$set(vm.$store.getters.todoItems[idx], "DoneAt", new Date());
            vm.$set(vm.$store.getters.todoItems[idx], "DoneBy", vm.$store.getters.me.ID);
            if(vm.reloadDataTable)vm.reloadDataTable();
          }
        //   vm.$alertMessage('已劃掉該待辦事項')
        })
        .finally(() => {
          vm.isLoading = false;
        });
    }
}
var todoItemAutoComplete = new TodoItemAutoComplete();
export default todoItemAutoComplete;